// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8910) return "static/chunks/8910-8e112380317a912f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1004":"41f8a0a9303a4906","1315":"f3763dbfb54f2b61","2048":"ee8ebf8f34f52a63","3847":"fe5b7df736fc8ad8","7181":"e720751117af74ea","8020":"afbe0792c00873ee","9080":"d917987226be07d2","9309":"da93b63e5e6f5c5f"}[chunkId] + ".js";
};